import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { typeTokens } from "../../../theme/tokens";

/**
 * Landing hero.
 *
 * No logged-in branch here: HomeRedirect only renders the landing page when
 * there is no user, so a "go to dashboard" state is unreachable.
 */
export default function Hero(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
      <Typography
        sx={{ ...typeTokens.microLabel, color: "text.secondary", mb: 2 }}
      >
        Booking workflow for small venues
      </Typography>

      <Typography variant="h2" fontWeight={800} gutterBottom>
        From first hold to final settlement.
      </Typography>

      <Typography
        variant="h6"
        color="text.secondary"
        maxWidth={720}
        mx="auto"
        sx={{ fontWeight: 400 }}
      >
        Solid Slate gives small rooms the booking workflow the big ones run on
        &mdash; 1st, 2nd, and 3rd holds, timed challenges, show advancement, and
        industry-standard settlement. Built for venues of 500 capacity and under.
      </Typography>

      <Button
        variant="contained"
        size="large"
        disableElevation
        onClick={() => navigate("/auth/signup")}
        sx={{ mt: 5, px: 4, py: 1.25 }}
      >
        Get Started
      </Button>
    </Box>
  );
}
